import { rem } from 'polished'

import { css, styled } from '../theme'
import { colors } from '../theme/colors'
import {
  HorizontalMarginProps,
  horizontalMarginsCss,
  VerticalMarginProps,
  verticalMarginsCss,
} from '../theme/css'
import { font } from '../theme/font'
import { media } from '../theme/media'

export const VerticalStepperWrapper = styled.div`
  display: flex;
  flex-direction: column;
`

export const HorizontalStepperWrapper = styled.div.attrs({})<
  VerticalMarginProps & HorizontalMarginProps
>`
  ${horizontalMarginsCss};
  ${verticalMarginsCss};
  display: flex;
  flex-direction: row;
`

export const Step = styled.div.attrs({})<{
  isSelected: boolean & VerticalMarginProps & HorizontalMarginProps
}>`
  position: relative;
  display: flex;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-items: flex-start;
  cursor: pointer;

  color: ${p => (p.isSelected ? colors.ternary : colors.grayDark)};
  ${font.sBold()}

  ${media.tablet`
      padding-right: 5px;
  `}
  ${media.desktop`
      padding-bottom: 10px;
  `}
`

export const StepNumber = styled.div.attrs({})<{
  isSelected: boolean
}>`
  display: inline-flex;
  position: relative;
  width: 30px;
  height: 30px;
  flex-basis: 30px;
  justify-content: center;
  align-items: center;

  ${media.upToDesktop` margin-left: 10px`};
  ${font.xsBold()}
  color: ${p => (p.isSelected ? colors.ternary : colors.grayDark)};

  box-sizing: border-box;
  background: ${colors.white};
  
  z-index: 2;

  &::before {
    content:'';
    position: absolute;
    height: 30px;
    width: 30px;
    border: 2px solid;
    border-color: ${p => (p.isSelected ? colors.ternary : colors.grayDark)};
    border-radius: 50%;
  }
  
  ${Step}:hover & {
    ${p =>
      !p.isSelected &&
      css`
        border-color: ${colors.primaryDark};
        color: ${colors.primaryDark};
      `}
  }
`

export const StepLabel = styled.div.attrs({})<{
  isSelected: boolean
}>`
  flex-wrap: wrap;
  justify-content: flex-start;
  margin-left: ${rem(10)};
  ${font.xsBold()}
  color: ${p => (p.isSelected ? colors.ternary : colors.grayDark)};

  ${Step}:hover & {
    ${p =>
      !p.isSelected &&
      css`
        border-color: ${colors.primaryDark};
        color: ${colors.primaryDark};
      `}
  }
`
